import axios from "axios";

const Api = axios.create({
   baseURL: process.env.VUE_APP_endpoint,
});

const Api2 = axios.create({
   baseURL: process.env.VUE_APP_endpoint2,
});

const Api3 = axios.create({
   baseURL: process.env.VUE_APP_endpoint3 ,
});

const attachToken = (config) => {
   const token = localStorage.getItem("token");
   if (token) {
      config.headers.Authorization = `Bearer ${token}`;
   }
   return config;
};

Api.interceptors.request.use(attachToken);
Api2.interceptors.request.use(attachToken);
Api3.interceptors.request.use(attachToken);

export { Api, Api2, Api3 };
